import {
  findIndexByPropertyValue
} from 'utilities/collection';

import attendeeStatuses from 'constants/attendee-statuses';

export function findAttendee(attendees, startupUserId) {

  const index = findIndexByPropertyValue(attendees, 'startupUserId', startupUserId);

  return attendees[index];

}

export function getAllUpcomingMeetingStatuesConfirmPromptHeader(status) {

  if (status === attendeeStatuses.ACCEPTED) {
    return 'Accept all upcoming meetings?';
  } else if (status === attendeeStatuses.MAY_BE) {
    return 'May attend all upcoming meetings?';
  } else if (status === attendeeStatuses.DECLINED) {
    return 'Decline all upcoming meetings?';
  }

}